import styled from 'styled-components';
import { selectThemeMode } from '../../redux/slices/themeSlice';
import { useSelector } from 'react-redux';

const StepsContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 10px;
  width: 100%;
  max-width: 300px;
`;

const Step = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 10px;
  height: 2px;
  ${({ done, theme, selectedTheme }) =>
    done
      ? `
    background-color: ${theme.primary.primary};
  `
      : `
      ${selectedTheme === 'dark' ? `opacity: 0.4;` : `opacity: 1;`}
    background-color: ${theme.primary.lighter};
  `}
`;

const Steps = ({ steps = 3, currentStep }) => {
  const selectedTheme = useSelector(selectThemeMode);
  return (
    <StepsContainer>
      {Array.from({ length: steps }, (_, index) => (
        <Step
          key={index}
          done={currentStep >= index}
          selectedTheme={selectedTheme}
        />
      ))}
    </StepsContainer>
  );
};

export default Steps;
